import React, { useEffect, useState } from "react";
import {
  Button,
  CustomInput,
  CustomSelect,
  DocumentsList,
  FormFieldSet,
  Modal,
  NewTable,
  StatusTags,
  TableAdv,
  useFormHandler,
} from "../../../../../components";
import { dateFormator, mapTableRows } from "../../../../../utils";
import { clientDocumentTableData } from "../../../../../assets/data/candidatesData";
import { getEmployeeByUiidStart } from "../../../../../redux/slices/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { getplacementDocumentsStart } from "../../../../../redux/slices/document/documentSlice";
import { transformFiles } from "../../../../../utils/transformFiles";
import { extractDocuments } from "../../../../../utils/extractDocuments";

const ClientDocuments = () => {
  const dispatch = useDispatch();
  const employeeProfileUiid = useSelector(
    (state) => state.employee.employeeProfileUiid
  );
  const { employeeDetails, loadedTabs } = useSelector(
    (state) => state.employee.currentEmployee
  );
  const documents = useSelector((state) => state.documents.taxForm) || {};
  const { placements } = employeeDetails || {};
  const { placements: placementsTableData } = useSelector(
    (state) => state.placement
  );
  const [documentModal, setDocumentModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const handleclick = (row) => {
    setDocumentModal(!documentModal);
    setSelectedDocuments(row);
  };

  const tableData = documents?.clientPlacement || [];

  const output = extractDocuments(tableData) || [];
  console.log("output", output);
  const columns = [
    {
      key: "firstName",
      label: "Consultant Name",
      sortable: false,
    },

    {
      key: "code",
      label: "Consultant Code",
      sortable: false,
      render: (row) => {
        return <div>{row?.permanentPlacement?.consultant?.code}</div>;
      },
    },
    {
      key: "placement",
      label: "Placement",
      sortable: false,
    },
    {
      key: "jobCode",
      label: "Job Code",
      sortable: false,
    },
    {
      key: "docType",
      label: "Document Type",
      sortable: false,
    },
    {
      key: "title",
      label: "Title",
      sortable: false,
    },
    {
      key: "comments",
      label: "Document Comments",
      sortable: false,
    },
    // {
    //   key: "expiryDate",
    //   label: "Expiry Date",
    //   render: (row) =>
    //     row.expiryDate ? dateFormator(row.expiryDate, "month-day-year") : "--",
    //   sortable: false,
    // }
    {
      key: "docExpiry",
      label: "Expiry Date",
      render: (row) => {
        const date = row.expiryDate;

        // Check for empty string, "--", null, undefined or anything falsy
        if (!date || date === "--") {
          return "--";
        }

        return dateFormator(date, "month-day-year");
      },
      sortable: false,
    },

    {
      key: "docStatus",
      label: "Status",
      render: (row) => <StatusTags tag={row.status} />,
      sortable: false,
    },
    {
      key: "documents",
      label: "Documents",
      render: (row) => (
        <div
          className="flex items-center gap-1 flex-row cursor-pointer"
        //   onClick={() => handleclick()}
        >
          <span
            className="text-linkblue"
            // onClick={() => handleclick([row])}
            onClick={
              transformFiles(row?.doc || []).length > 0
                ? () => handleclick(transformFiles(row?.doc || []))
                : () => { }
            }
          >
            {transformFiles(row?.doc || []).length} Docs{" "}
          </span>
        </div>
      ),
      sortable: false,
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2 flex-row">
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
          />
          {/* <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
          /> */}
        </div>
      ),
      sortable: false,
    },
  ];
  const mappedRows = mapTableRows(output, columns);
console.log("mappedRows",mappedRows);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler({
    Placement: "",
    documentType: "",
    status: "",
  });

  useEffect(() => {
    dispatch(
      getEmployeeByUiidStart({
        uiid: employeeProfileUiid,
        tab: "placementsTab",
        ret: "placements",
        // ref:"Document",
      })
    );
  }, []);
  useEffect(() => {
    dispatch(
      getplacementDocumentsStart({
        fil: {
          uiid: { type: "IN", value: placements },
          "jobInfo.entityType": { type: "NONE", value: "Client" },
        },
        cache: false,
        ret: "clientPlacement",
        ref: "Document",
      })
    );
  }, [placements]);
  return (
    <div className="mt-3">
      <TableAdv
        rows={mappedRows}
        columns={columns}
        tableId={`Employee_Documents_Clientdocuments`}
        toolbarRight={{
          search: false,
          filter: false,
          download: false,
          add: [
            {
              component: (
                <div className=" flex max-w-7xl gap-4 mt-2 mb-2 ">
                  <FormFieldSet
                    type="select"
                    title=" Placement"
                    placeholder="Select Placement"
                    value={formData.Placement || ""}
                    onChange={(value) => handleChange("Placement", value)}
                    error={errors.Placement}
                    options={""}
                  />
                  <FormFieldSet
                    type="select"
                    title=" Document Type"
                    placeholder="Select Document Type"
                    value={formData.documentType || ""}
                    onChange={(value) => handleChange("documentType", value)}
                    error={errors.documentType}
                    options={""}
                  />
                  <FormFieldSet
                    type="select"
                    title=" Status"
                    placeholder="Select Status"
                    value={formData.status || ""}
                    onChange={(value) => handleChange("status", value)}
                    error={errors.status}
                    options={""}
                  />
                </div>
              ),
            },
          ],
        }}

      />
      <Modal
        isOpen={documentModal}
        onClose={() => setDocumentModal(false)}
        title="Document Details"
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default ClientDocuments;
